import React from 'react';
import PropTypes from 'prop-types';
import { noop, isUndefined, isEmpty } from 'lodash';
import classnames from 'classnames';

// dependencies
import { Icon } from 'modules/icon-bank';

/************************************************/

// icons `id` based on value
const getIconId = ( value ) => {
    if( true === value ) {
        return 'pass';
    } else if( undefined === value ) {
        return 'dash';
    } else {
        return undefined;
    }
};

/*----------------------------------------------*/

/**
 * @type {object}
 * @desc This React view renders a chexbox that can maintain `checked`, `intermediate` and `unchecked` state.
 * @example
 * import { checkbox } from 'ui/views/generic/checkbox';
 *
 * // render
 * <checkbox propName='propValue'/>
 */
export const checkbox = ( props ) => {

    // icon id
    const iconId = getIconId( props.value );

    // checbox class
    const widgetClassNames = classnames( 'ui-checkbox', props.className, {
        'ui-checkbox--outline': isUndefined( iconId ),
        [ `ui-checkbox--size-${ props.size }` ]: ! isEmpty( props.size ),
        [ `ui-checkbox--theme-${ props.theme }` ]: ! isEmpty( props.theme ),
        [ 'ui-checkbox--pass' ]: ( 'cloud-gray'=== props.theme && 'pass' === iconId ),
        [ 'ui-checkbox--disabled' ]: props.disabled
    } );

    const _onChangeHandler = props.disabled ? noop : props.onClick;
    
    
    return (
        <div className={ widgetClassNames } onClick={ ()=>{props.disabled?noop: _onChangeHandler }  } tabIndex={props.tabIndex} >
            <div className='ui-checkbox__icon'>
                {
                    isUndefined( iconId ) ? null : <Icon id={ iconId } fill='#fff'/>
                }
            </div>
        </div>
    );
};

// set display name
checkbox.displayName = 'checkbox';

// set default props
checkbox.defaultProps = {
    onClick: noop,
    size: undefined,
    theme: undefined,
    tabIndex: 0
};

// prop types
checkbox.propTypes = {
    value: PropTypes.oneOf( [ true, false, undefined ] ),
    onClick: PropTypes.func,
    theme: PropTypes.string,
    size: PropTypes.string,
};
